import styles from './breadcrumb.module.css';
import { useLocation, Link } from "react-router-dom";
import routes from '../../../config/routes';
import { getName } from "../../../config/sideMenuData";
import React, { useState, useEffect } from "react";
import { useTheme } from '../../../config/themeContext';
import { useMemo } from 'react';
import { Icons } from '../../../code/IconHandler';
import { forceReload } from '../FussballDeWidget/FussballDeWidget';

const getTeamLabel = (slug) => {
    if (!slug) return "";

    const seniorenMatch = slug.match(/^senioren-(\d+)-(herren|damen)$/i);
    if (seniorenMatch) {
        const [_, num, gender] = seniorenMatch;
        return `${num}. ${gender === "herren" ? "Herren" : "Damen"}`;
    }

    const juniorMatch = slug.match(/^(junioren|juniorinnen)-u(\d+)(?:-(\d+))?$/i);
    if (juniorMatch) {
        const [_, group, age, sub] = juniorMatch;
        const genderSuffix = group.toLowerCase() === "juniorinnen" ? "(Juniorinnen)" : "";
        return (sub ? `U${age}.${sub} ${genderSuffix}` : `U${age} ${genderSuffix}`);
    }

    const talentwerkMatch = slug.match(/^talentwerk-u(\d+)(?:-(\d+))?$/i);
    if (talentwerkMatch) {
        const [_, age, sub] = talentwerkMatch;
        return sub ? `Talentwerk U${age}-${sub}` : `Talentwerk U${age}`;
    }

    return slug
        .split('-')
        .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' '); // fallback
};

function Breadcrumb() {
    const location = useLocation();
    const { isBright } = useTheme();
    const pathSegments = location.pathname
        .split("/")
        .filter(Boolean)
        .map(segment => decodeURIComponent(segment));

    // ✅ Move hooks before any early return
    const interesting_path = useMemo(() => pathSegments.slice(0), [pathSegments]);
    const [title, setTitle] = useState(null);
    const slug = interesting_path[1] || "";

    const isValidRoute = routes.some(route =>
        route.path !== "*" &&
        (location.pathname === route.path || location.pathname.startsWith(route.path + "/"))
    );
    useEffect(() => {
        if (interesting_path[0] && interesting_path[0].toLocaleLowerCase() === 'news' && slug) {
            fetch(`/api/news/get_news_title_by_slug/${slug}`)
                .then((res) => res.json())
                .then((data) => {
                    if (data[0].title) {
                        setTitle(data[0].title);
                    }
                })
                .catch((err) => {
                    console.error("Fetch error:", err);
                });
        }
    }, [slug]);

    const combine = (index) => "/" + pathSegments.slice(0, index + 1).join("/");
    let val = '';
    let isPanel = false;
    let isOther = false;
    let hasTask = false;
    // ✅ Now check pathSegments.length AFTER hooks have been called
    if (pathSegments.length === 0) {
        return null;
    }
    if ('news' === interesting_path[0].toLocaleLowerCase() && interesting_path.length > 1) {
        return (
            <nav className={`${styles.breadcrumb} ${isBright ? styles.light : styles.dark}`}>
                <span className={styles.dummy}></span>
                <div className={styles.wrapper}>
                    <Link className={styles.link} to={"/"}>Startseite</Link>
                    <Icons.ArrowRight className={styles.arrow} />
                    <Link className={styles.link} to={"/news"}>News</Link>
                    <Icons.ArrowRight className={styles.arrow} />
                    <Link className={styles.link} to={`/news/${slug}`}>{title}</Link>
                </div>

            </nav>
        );

    } else if (interesting_path[0]?.toLowerCase() === 'admin') {
        if (interesting_path[1] === 'panel') {
            isPanel = true;
            if (interesting_path[2]) {
                hasTask = true;
                switch (interesting_path[2]) {
                    case 'banner':
                        val = 'AlertBanner-Editor';
                        break;
                    case 'change-password':
                        val = 'Passwort ändern';
                        break;
                    case 'create-news':
                        val = 'News erstellen';
                        break;
                    case 'handle-news':
                        val = 'News verwalten';
                        break;
                    case 'handle-matches':
                        val = 'Fußballspiele verwalten';
                        break;
                    case 'user-management':
                        val = 'Benutzerverwaltung';
                        break;
                    case 'handle-camps':
                        val = 'Camps verwalten';
                        break;
                    case 'handle-contacts':
                        val = 'Kontakte verwalten';
                        break;
                    case 'handle-locations':
                        val = 'Sportstätten verwalten';
                        break;
                    case 'handle-sportmodules':
                        val = 'Sportmodule verwalten';
                        break;
                    case 'handle-herobanner':
                        val = 'Hero-Banner verwalten';
                        break;
                    case 'handle-teams':
                        val = 'Teams verwalten';
                        break;
                    default: val = '-/-';
                }
            }
        } else if (interesting_path[1] === 'reset-password') {
            val = "Passwort zurücksetzen";
            isOther = true;
        } else if (interesting_path[1] === 'forgot-password') {
            val = "Passwort vergessen";
            isOther = true;
        }



        return (
            <nav className={`${styles.breadcrumb} ${isBright ? styles.light : styles.dark}`}>
                <span className={styles.dummy}></span>
                <div className={styles.wrapper}>
                    <Link className={styles.link} to={"/"}>Startseite</Link>
                    <Icons.ArrowRight className={styles.arrow} />
                    <Link className={styles.link} to={"/admin"}>{isPanel ? 'Adminbereich' : 'Login'}</Link>

                    {hasTask && (

                        <>
                            <Icons.ArrowRight className={styles.arrow} />
                            <Link className={styles.link} to={`/admin/panel/${interesting_path[2]}`}>{val}</Link>
                        </>
                    )}
                    {isOther && (
                        <>
                            <Icons.ArrowRight className={styles.arrow} />
                            <Link className={styles.link} to={`/admin/${interesting_path[1]}`}>{val}</Link>
                        </>
                    )}
                </div>
            </nav>
        )
    } else if (
        interesting_path[0] === 'mannschaftssport' &&
        interesting_path[1] === 'fußball' &&
        interesting_path[2]
    ) {
        const teamSlug = interesting_path[2];
        const teamLabel = getTeamLabel(teamSlug);

        return (
            <nav className={`${styles.breadcrumb} ${isBright ? styles.light : styles.dark}`}>
                <span className={styles.dummy}></span>
                <div className={styles.wrapper}>
                    <Link className={styles.link} to="/">Startseite</Link>
                    <Icons.ArrowRight className={styles.arrow} />
                    <Link className={styles.link} to="/mannschaftssport">Mannschaftssport</Link>
                    <Icons.ArrowRight className={styles.arrow} />
                    {forceReload("/mannschaftssport/fußball") ? (
                        <a className={styles.link} href={"/mannschaftssport/fußball"}>Fußball</a> // hard reload
                    ) : (
                        <Link className={styles.link} to={"/mannschaftssport/fußball"}>Fußball</Link> // client-side navigation
                    )}
                    <Icons.ArrowRight className={styles.arrow} />
                    {forceReload(`/mannschaftssport/fußball/${teamSlug}`) ? (
                        <a className={styles.link} href={`/mannschaftssport/fußball/${teamSlug}`}>{teamLabel}</a> // hard reload
                    ) : (
                        <Link className={styles.link} to={`/mannschaftssport/fußball/${teamSlug}`}>{teamLabel}</Link> // client-side navigation
                    )}
                </div>
            </nav>
        );
    }
    return (
        <nav className={`${styles.breadcrumb} ${isBright ? styles.light : styles.dark}`}>
            <span className={styles.dummy}></span>
            <div className={styles.wrapper}>
                <Link className={styles.link} to={"/"}>Startseite</Link>
                {isValidRoute ? (
                    interesting_path.map((segment, index) => {
                        const url = combine(index);
                        const name = getName(url);
                        return (
                            <React.Fragment key={url}>
                                <Icons.ArrowRight className={styles.arrow} />
                                {forceReload(url) ? (
                                    <a className={styles.link} href={url}>{name}</a> // hard reload
                                ) : (
                                    <Link className={styles.link} to={url}>{name}</Link> // client-side navigation
                                )}


                            </React.Fragment>
                        );
                    })
                ) : (
                    // ✅ If no valid route, show "Error"
                    <>
                        <Icons.ArrowRight className={styles.arrow} />
                        <span className={styles.error}>Error</span>
                    </>
                )}

            </div>
        </nav>
    )
}




export default Breadcrumb;